<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <input
            type="button"
            :value="cancelButton"
            class="cancel_button"
            @click="cancel"
          />
          <input
            type="button"
            :value="finishButton"
            class="finish_button"
            @click="update"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="detail_top">
            <div class="image">
              <img :src="profilePicture" />
              <form class="photo_file_uploader" id="photo_file_uploader">
                <input
                  type="text"
                  class="hidden_txt"
                  readonly
                  :placeholder="pictureLabel"
                />
                <input
                  type="file"
                  class="uploader"
                  name="uploader"
                  @change="fileUpload"
                />
              </form>
              <div>
                <div class="disabled_delete_photo" v-if="isBlankFile">
                  {{ pictureDeleteLabel }}
                </div>
                <div
                  class="photo_delete_button"
                  @click="showDeletePictureModal = true"
                  v-else
                >
                  {{ pictureDeleteLabel }}
                </div>
              </div>
            </div>
            <div class="profile_content">
              <div class="pronunciation">
                <div class="pronunciation_label detail_label">
                  {{ pronunciationLabel }}
                  <div class="require_items_label">
                    {{ requiredItemLabel }}
                  </div>
                </div>
                <input
                  class="detail_input_field"
                  type="text"
                  v-model="careworker.pronunciation"
                  @input="inputUpdate('pronunciation')"
                />
              </div>
              <div class="careworker_name">
                <div class="careworker_name_label detail_label">
                  {{ careworkerNameLabel }}
                  <div class="require_items_label">
                    {{ requiredItemLabel }}
                  </div>
                </div>
                <input
                  class="family_name detail_input_field"
                  type="text"
                  v-model="careworker.familyName"
                  @input="inputUpdate('familyName')"
                />
                <input
                  class="name detail_input_field"
                  type="text"
                  v-model="careworker.name"
                  @input="inputUpdate('name')"
                />
              </div>
            </div>
          </div>
          <div class="user_id detail_content">
            <div class="user_id_label detail_label">
              {{ userIdLabel }}
            </div>
            <div id="user_id">
              {{ careworker.userId }}
            </div>
          </div>
          <div class="post_label detail_label">
            {{ postLabel }}
            <div class="require_items_label">
              {{ requiredItemLabel }}
            </div>
          </div>
          <input
            type="button"
            :value="settingPostButton"
            class="setting_post_button"
            @click="settingPostModal = true"
          />
          <div class="post_name detail_content">
            <div class="post_name_label detail_label">
              {{ mainPostLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <select
              class="drop_down_list"
              @change="inputPostAddUpdate('postId')"
            >
              <option disabled selected value="">
                {{ selectedPostName }}
              </option>
              <option
                v-for="post in dropdownPostList"
                :value="post.postId"
                :key="post.postId"
              >
                {{ post.postName }}
              </option>
            </select>
          </div>
          <div class="job detail_content">
            <div class="job_label detail_label">
              {{ jobLabel }}
            </div>
            <input
              class="job detail_input_field"
              type="text"
              v-model="careworker.job"
              @input="inputUpdate('job')"
            />
          </div>
          <div class="position detail_content">
            <div class="position_label detail_label">
              {{ positionLabel }}
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="careworker.position"
              @input="inputUpdate('position')"
            />
          </div>
          <form class="birthday detail_content">
            <div class="birthday_label detail_label">
              {{ birthdayLabel }}
            </div>
            <select class="birthday_drop_down_list" id="year">
              <option v-for="n in editYear" :key="n">
                {{ n + 1900 }}
              </option>
              <option disabled selected>{{ birthdayYear }}</option>
            </select>
            <select class="birthday_drop_down_list" id="month">
              <option disabled selected>{{ birthdayMonth }}</option>
              <option v-for="n in 12" :key="n">
                {{ n }}
              </option>
            </select>
            <select class="birthday_drop_down_list" id="day">
              <option disabled selected>{{ birthdayDay }}</option>
              <option v-for="n in 31" :key="n">
                {{ n }}
              </option>
            </select>
          </form>
          <div class="memo_detail_content">
            <div class="memo_label detail_label">
              {{ memoLabel }}
            </div>
            <textarea
              class="detail_input_field memo"
              type="text"
              v-model="careworker.memo"
              @input="inputUpdate('memo')"
            ></textarea>
          </div>
          <div class="password detail_content">
            <div class="password_label detail_label">
              {{ passwordLabel }}
            </div>
            <div class="password_change">
              <input
                type="button"
                :value="passwordDeleteButton"
                class="password_change_button"
                @click="showDeletePasswordModal = true"
                :disabled="!passwordEnableFlag"
                :style="{backgroundColor: buttonColor}"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="edit_bottom">
        <input
          type="button"
          :value="deleteButton"
          class="edit_delete_button"
          @click="showDeleteModal = true"
        />
      </div>
      <div class="modal_window" v-if="showDeleteModal">
        <deleteModalWindow
          :question="deleteWord"
          :router="router"
          @close="stayClose"
          @remove="remove"
        >
        </deleteModalWindow>
      </div>
      <div class="modal_window" v-if="showDeletePictureModal">
        <deleteModalWindow
          :question="pictureDeleteWord"
          :router="router"
          @close="stayClose"
          @remove="fileDelete"
        >
        </deleteModalWindow>
      </div>
      <div class="modal_window" v-if="showDeletePasswordModal">
        <deletePasswordModalWindow
          :question="passwordDeleteWord"
          @close="stayClose"
          @ok="deletePassword"
        >
        </deletePasswordModalWindow>
      </div>
      <div class="modal_window" v-if="showCompleteDeletePasswordModal">
        <completeModalWindow
          :question="completeDeletePassword"
          @close="stayClose"
        >
        </completeModalWindow>
      </div>
      <div class="modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="modal_window" v-if="showDeleteImageCompleteModal">
        <completeModalWindow :question="completeWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
      <div class="modal_window" v-if="settingPostModal">
        <settingPostModalWindow
          :dispItems="posts"
          :selItems="selectItems"
          @close="closeSettingPostModal"
          @changePost="changePost"
        >
        </settingPostModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import deleteModalWindow from '../modalWindow/detailDeleteModalWindow.vue'
import deletePasswordModalWindow from '../modalWindow/confirmModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import settingPostModalWindow from '../modalWindow/settingPostModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      finishButton: '完了',
      deleteButton: 'この情報を削除',
      pictureLabel: '画像を変更',
      pictureDeleteLabel: '画像を削除',
      pronunciationLabel: 'ふりがな',
      careworkerNameLabel: '名前',
      userIdLabel: 'ユーザID',
      postLabel: '所属',
      mainPostLabel: 'メイン所属',
      jobLabel: '職種',
      positionLabel: '役職',
      birthdayLabel: '生年月日',
      memoLabel: '補足情報',
      passwordLabel: 'パスワード',
      passwordDeleteButton: 'パスワード初期化',
      pictureDeleteWord: '設定中の画像を削除してよろしいですか？',
      passwordDeleteWord: '本当にパスワードを初期化しますか？',
      completeDeletePassword: 'パスワードを初期化しました。',
      settingPostButton: '所属の設定',
      completeWord: '',
      failureWord: '',
      selectedPostId: [],
      dropdownPostList: [],
      subPostList: [],
      selectItems: [],
      router: '/careworkers',
      showDeleteModal: false,
      showDeletePictureModal: false,
      showDeletePasswordModal: false,
      showCompleteDeletePasswordModal: false,
      showCompleteModal: false,
      showDeleteImageCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      settingPostModal: false,
      changeMainPost: false,
      selectedPostName: '',
      selectedMainPostId: '',
      canselSelectPostId: []
    }
  },
  computed: {
    careworker() {
      return this.$store.state.careworkers.careworker
    },
    profilePicture() {
      return this.$store.state.careworkers.changeThumbnailPhotograph
    },
    careworkerName() {
      return (
        this.$store.state.careworkers.careworker.familyName +
        this.$store.state.careworkers.careworker.name
      )
    },
    birthdayYear() {
      if (this.$store.state.careworkers.careworker.birthday) {
        let date = new Date(this.$store.state.careworkers.careworker.birthday)
        let year = date.getFullYear()
        return year
      } else {
        return ''
      }
    },
    birthdayMonth() {
      if (this.$store.state.careworkers.careworker.birthday) {
        let date = new Date(this.$store.state.careworkers.careworker.birthday)
        let month = date.getMonth() + 1
        return month
      } else {
        return ''
      }
    },
    birthdayDay() {
      if (this.$store.state.careworkers.careworker.birthday) {
        let date = new Date(this.$store.state.careworkers.careworker.birthday)
        let day = date.getDate()
        return day
      } else {
        return ''
      }
    },
    editYear() {
      let now = new Date()
      // 1900年から現在の年までの二桁数字
      return now.getYear()
    },
    deleteWord() {
      return this.careworkerName + 'さんの情報を削除してよろしいですか？'
    },
    posts() {
      return this.$store.state.careworkers.posts
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    passwordEnableFlag() {
      return this.$store.state.masters.passwordEnableFlagMaster
        .passwordEnableFlag
    },
    buttonColor() {
      if (this.passwordEnableFlag) {
        return '#00afa8'
      } else {
        return '#C0C0C0'
      }
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    selectedPosts() {
      return this.$store.state.careworkers.selectedposts
    },
    isBlankFile() {
      const userFile = this.$store.state.careworkers.careworker
        .thumbnailPhotograph
      return userFile === '' || userFile === null
    }
  },
  components: {
    deleteModalWindow,
    deletePasswordModalWindow,
    completeModalWindow,
    loadingModalWindow,
    settingPostModalWindow
  },
  async created() {
    this.showloadingModal = true
    this.selectedPostId = []
    let postId = this.careworker.postId
    let postName = this.careworker.postName
    this.dropdownPostList.push({postId, postName})
    this.selectItems.push(postId)
    postId = this.careworker.sub1PostId
    postName = this.careworker.sub1PostName
    if (postId !== '' && postId !== null) {
      this.dropdownPostList.push({postId, postName})
      this.selectItems.push(postId)
    }
    postId = this.careworker.sub2PostId
    postName = this.careworker.sub2PostName
    if (postId !== '' && postId !== null) {
      this.dropdownPostList.push({postId, postName})
      this.selectItems.push(postId)
    }
    postId = this.careworker.sub3PostId
    postName = this.careworker.sub3PostName
    if (postId !== '' && postId !== null) {
      this.dropdownPostList.push({postId, postName})
      this.selectItems.push(postId)
    }
    postId = this.careworker.sub4PostId
    postName = this.careworker.sub4PostName
    if (postId !== '' && postId !== null) {
      this.dropdownPostList.push({postId, postName})
      this.selectItems.push(postId)
    }
    this.selectedMainPostId = this.careworker.postId
    this.selectedPostName = this.careworker.postName
    this.canselSelectPostId = Array.from(this.selectItems)
    this.$store.dispatch('careworkers/inputUpdate', {
      name: 'postName',
      value: this.careworker.postName
    })

    try {
      await this.$store.dispatch('careworkers/setPost')
      await this.$store.dispatch('careworkers/setSelectedcPost')
    } catch (error) {
      let eventNumber = this.$store.state.error.errorCode.errorCode_370002
      let eventType = 3
      let reason = 'MSGCRC0035 '
      if (error.response) {
        this.failureWord =
          this.errorMsg.MSGCRC0035.name +
          this.errorMsg.MSGCRC0035.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        reason += error.response.status
      } else {
        reason = 'MSGCRC0005'
        eventType = 9
        this.failureWord =
          this.errorMsg.MSGCRC0005.name +
          this.errorMsg.MSGCRC0005.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
      try {
        this.$store.dispatch('masters/writeLog', {
          eventNumber,
          eventType,
          reason
        })
      } catch (error) {}
      this.showFailureModal = true
    }
    this.showloadingModal = false
  },
  methods: {
    inputUpdate(e) {
      this.$store.dispatch('careworkers/inputUpdate', {
        name: e,
        value: event.target.value
      })
    },
    inputPostAddUpdate(e) {
      this.$store.dispatch('careworkers/inputUpdate', {
        name: e,
        value: event.target.value
      })
      this.inputSubPostAddUpdate(event.target.value)
      this.changeMainPost = true
    },
    inputSubPostAddUpdate(postId) {
      this.subPostList = []
      this.selectedPostName = this.dropdownPostList.find(
        item => item.postId === postId
      ).postName
      this.$store.dispatch('careworkers/inputUpdate', {
        name: 'postName',
        value: this.selectedPostName
      })
      this.selectedMainPostId = postId
      for (var i = 0; i < this.dropdownPostList.length; i++) {
        if (postId !== this.dropdownPostList[i]['postId']) {
          let postId = this.dropdownPostList[i]['postId']
          let postCode = this.dropdownPostList[i]['postCode']
          this.subPostList.push({postId, postCode})
        }
      }
      this.subPostList.sort(function(a, b) {
        if (a.postCode > b.postCode) {
          return 1
        } else if (a.postCode < b.postCode) {
          return -1
        } else {
          return 0
        }
      })
      // サブ所属の更新は洗い替えする（まずは初期化する）
      this.$store.dispatch('careworkers/inputUpdate', {
        name: 'sub1PostId',
        value: ''
      })
      this.$store.dispatch('careworkers/inputUpdate', {
        name: 'sub2PostId',
        value: ''
      })
      this.$store.dispatch('careworkers/inputUpdate', {
        name: 'sub3PostId',
        value: ''
      })
      this.$store.dispatch('careworkers/inputUpdate', {
        name: 'sub4PostId',
        value: ''
      })
      for (var j = 0; j < this.subPostList.length; j++) {
        let subPostId = this.subPostList[j]['postId']
        this.$store.dispatch('careworkers/inputUpdate', {
          name: 'sub' + [j + 1] + 'PostId',
          value: subPostId
        })
      }
    },
    async cancel(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'careworkers/setDetailCareworker',
          this.$store.state.careworkers.careworker
        )
        try {
          if (this.$store.state.careworkers.careworker.thumbnailPhotograph) {
            await this.$store.dispatch(
              'careworkers/fileDownload',
              this.$store.state.careworkers.careworker.thumbnailPhotograph
            )
          }
          this.$router.push('../careworkers/detail')
        } catch (error) {
          this.$store.dispatch('careworkers/fileDownloadErrorFlg', true)
          // 画像ダウンロード失敗の場合でも画面遷移する
          this.$router.push('../careworkers/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_250001
        let eventType = 3
        let reason = 'MSGCRC0048 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0048.name +
            this.errorMsg.MSGCRC0048.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async update(e) {
      this.showloadingModal = true
      let year = document.getElementById('year').value
      /** @description new Date()関数のMonth引数調整 */
      let month = Number(document.getElementById('month').value) - 1
      /** @description new Date()関数のDay引数調整 */
      let day = Number(document.getElementById('day').value) + 1
      let birthday = new Date(year, month, day)
      // サブ所属の更新
      this.inputSubPostAddUpdate(this.selectedMainPostId)
      try {
        await this.$store.dispatch('careworkers/updateCareworker', birthday)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_250003
        let eventType = 3
        let reason = ''
        if (error.response && error.response.data) {
          if (error.response.data.header) {
            let errorMessage = error.response.data.header.message
            if (errorMessage === 'MSGCRC0041') {
              this.failureWord =
                this.errorMsg.MSGCRC0041.name +
                this.errorMsg.MSGCRC0041.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0042') {
              this.failureWord =
                this.errorMsg.MSGCRC0042.name +
                this.errorMsg.MSGCRC0042.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0043') {
              this.failureWord =
                this.errorMsg.MSGCRC0043.name +
                this.errorMsg.MSGCRC0043.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0044') {
              this.failureWord =
                this.errorMsg.MSGCRC0044.name +
                this.errorMsg.MSGCRC0044.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0045') {
              this.failureWord =
                this.errorMsg.MSGCRC0045.name +
                this.errorMsg.MSGCRC0045.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0102') {
              this.failureWord =
                this.errorMsg.MSGCRC0102.name +
                this.errorMsg.MSGCRC0102.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0103') {
              this.failureWord =
                this.errorMsg.MSGCRC0103.name +
                this.errorMsg.MSGCRC0103.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0104') {
              this.failureWord =
                this.errorMsg.MSGCRC0104.name +
                this.errorMsg.MSGCRC0104.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0105') {
              this.failureWord =
                this.errorMsg.MSGCRC0105.name +
                this.errorMsg.MSGCRC0105.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0106') {
              this.failureWord =
                this.errorMsg.MSGCRC0106.name +
                this.errorMsg.MSGCRC0106.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0107') {
              this.failureWord =
                this.errorMsg.MSGCRC0107.name +
                this.errorMsg.MSGCRC0107.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0198') {
              this.failureWord =
                this.errorMsg.MSGCRC0198.name +
                this.errorMsg.MSGCRC0198.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0264') {
              this.failureWord =
                this.errorMsg.MSGCRC0264.name +
                this.errorMsg.MSGCRC0264.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0273') {
              this.failureWord =
                this.errorMsg.MSGCRC0273.name +
                this.errorMsg.MSGCRC0273.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.failureWord =
                this.errorMsg.MSGCRC0049.name +
                this.errorMsg.MSGCRC0049.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage + ' '
            reason += error.response.status
          } else {
            var obj = error.response.data
            var stringName = Object.keys(obj)[0]
            if (stringName.endsWith('birthday')) {
              this.failureWord =
                this.errorMsg.MSGCRC0144.name +
                this.errorMsg.MSGCRC0144.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0144'
            } else {
              this.failureWord =
                this.errorMsg.MSGCRC0049.name +
                this.errorMsg.MSGCRC0049.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0049'
            }
          }
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch(
          'careworkers/setDetailCareworker',
          this.$store.state.careworkers.careworker
        )
        try {
          if (this.$store.state.careworkers.careworker.thumbnailPhotograph) {
            await this.$store.dispatch(
              'careworkers/fileDownload',
              this.$store.state.careworkers.careworker.thumbnailPhotograph
            )
          }
          this.$emit('list-reload')
          this.$router.push('../careworkers/detail')
        } catch (error) {
          this.$store.dispatch('careworkers/fileDownloadErrorFlg', true)
          // 画像ダウンロード失敗の場合でも画面遷移する
          this.$router.push('../careworkers/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_250002
        let eventType = 3
        let reason = 'MSGCRC0048 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0048.name +
            this.errorMsg.MSGCRC0048.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    close(e) {
      this.showDeleteModal = false
      this.showCompleteModal = false
      this.showDeleteImageCompleteModal = false
      this.showDeletePasswordModal = false
      this.showDeletePictureModal = false
      this.showCompleteDeletePasswordModal = false
      this.$router.push(this.router)
      this.settingPostModal = false
    },
    closeSettingPostModal(e) {
      this.settingPostModal = false
      this.selectItems = Array.from(this.canselSelectPostId)
    },
    async changePost(e) {
      this.dropdownPostList = []
      this.canselSelectPostId = []
      this.subPostList = []
      this.selectedPostId = e
      // this.selectedPostIdには所属IDしか持っていないためIDに紐づく情報をthis.dropdownPostListに入れる
      for (var i = 0; i < this.selectedPostId.length; i++) {
        for (var j = 0; j < this.selectedPosts.length; j++) {
          if (this.selectedPostId[i] === this.selectedPosts[j]['postId']) {
            let postId = this.selectedPosts[j]['postId']
            let postName = this.selectedPosts[j]['postName']
            let postCode = this.selectedPosts[j]['postCode']
            this.dropdownPostList.push({postId, postName, postCode})
            this.canselSelectPostId.push(postId)
          }
        }
      }
      this.dropdownPostList.sort(function(a, b) {
        if (a.postCode > b.postCode) {
          return 1
        } else if (a.postCode < b.postCode) {
          return -1
        } else {
          return 0
        }
      })
      let selectedId = this.selectedMainPostId
      var data = this.dropdownPostList.filter(function(row) {
        return row.postId === selectedId
      })
      if (data.length === 0) {
        // メイン所属に設定していた所属のチェックを外した場合
        this.selectedMainPostId = ''
        this.selectedPostName = ''
        this.$store.dispatch('careworkers/inputUpdate', {
          name: 'postId',
          value: ''
        })
      }

      if (this.selectedMainPostId === '') {
        this.selectedMainPostId = this.dropdownPostList[0]['postId']
        this.selectedPostName = this.dropdownPostList[0]['postName']
      }
      this.$store.dispatch('careworkers/inputUpdate', {
        name: 'postId',
        value: this.selectedMainPostId
      })
      this.settingPostModal = false
    },
    stayClose(e) {
      this.showDeleteModal = false
      this.showCompleteModal = false
      this.showDeleteImageCompleteModal = false
      this.showDeletePasswordModal = false
      this.showDeletePictureModal = false
      this.showCompleteDeletePasswordModal = false
      this.showFailureModal = false
    },
    async remove(e) {
      this.showloadingModal = true
      let userId = this.$store.state.careworkers.careworker.userId
      let deleteList = [{userId}]
      try {
        await this.$store.dispatch('careworkers/deleteCareworkers', deleteList)
        this.$emit('list-reload')
        this.showDeleteModal = false
        this.completeWord = '削除しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_250004
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0050') {
            this.failureWord =
              this.errorMsg.MSGCRC0050.name +
              this.errorMsg.MSGCRC0050.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.failureWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async deletePassword(e) {
      // パスワード初期化のコードを記述
      this.showloadingModal = true
      try {
        await this.$store.dispatch('careworkers/deletePassword')
        this.$emit('list-reload')
        this.showDeletePasswordModal = false
        this.completeDeletePassword = 'パスワードを初期化しました。'
        this.showCompleteDeletePasswordModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_250006
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0052') {
            this.failureWord =
              this.errorMsg.MSGCRC0052.name +
              this.errorMsg.MSGCRC0052.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.failureWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async fileDelete(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'careworkers/fileDelete',
          this.$store.state.careworkers.userId
        )
        this.showDeletePictureModal = false
        this.completeWord = '削除しました。'
        this.showDeleteImageCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_250009
        let eventType = 3
        let reason = 'MSGCRC0274'
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0274.name +
            this.errorMsg.MSGCRC0274.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      document.getElementById('photo_file_uploader').reset()
      this.showloadingModal = false
    },
    async fileUpload(e) {
      this.showloadingModal = true
      var result = e.target.files[0]
      var limit = 1048576
      if (result) {
        var smallPhotoName = result.name.toLowerCase()
        if (
          smallPhotoName.endsWith('.png') ||
          smallPhotoName.endsWith('.jpg') ||
          smallPhotoName.endsWith('.jpeg') ||
          smallPhotoName.endsWith('.gif')
        ) {
          if (result.size < limit) {
            let isValid = await this.isValidImageFile(e.target.files[0])
            if (!isValid) {
              let eventNumber = this.$store.state.error.errorCode
                .errorCode_250005
              let eventType = 3
              let reason = 'MSGCRC0301'
              eventType = 9
              this.failureWord =
                this.errorMsg.MSGCRC0301.name +
                this.errorMsg.MSGCRC0301.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              try {
                this.$store.dispatch('masters/writeLog', {
                  eventNumber,
                  eventType,
                  reason
                })
              } catch (error) {}
              this.showFailureModal = true
              this.showloadingModal = false
              e.target.value = ''
              return
            }
            try {
              await this.$store.dispatch(
                'careworkers/fileUpload',
                e.target.files[0]
              )
              try {
                if (
                  this.$store.state.careworkers.careworker.thumbnailPhotograph
                ) {
                  await this.$store.dispatch(
                    'careworkers/fileDownload',
                    this.$store.state.careworkers.careworker.thumbnailPhotograph
                  )
                }
              } catch (error) {
                this.$store.dispatch(
                  'careworkers/setNoimageChangeThumbnailPhotograph'
                )
                let eventNumber = this.$store.state.error.errorCode
                  .errorCode_250005
                let eventType = 3
                let reason = 'MSGCRC0196 '
                this.failureWord =
                  this.errorMsg.MSGCRC0196.name +
                  this.errorMsg.MSGCRC0196.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
                try {
                  this.$store.dispatch('masters/writeLog', {
                    eventNumber,
                    eventType,
                    reason
                  })
                } catch (error) {}
                this.showFailureModal = true
              }
            } catch (error) {
              let eventNumber = this.$store.state.error.errorCode
                .errorCode_250005
              let eventType = 3
              let reason = 'MSGCRC0051 '
              if (error.response) {
                this.failureWord =
                  this.errorMsg.MSGCRC0051.name +
                  this.errorMsg.MSGCRC0051.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
                reason += error.response.status
              } else {
                reason = 'MSGCRC0005'
                eventType = 9
                this.failureWord =
                  this.errorMsg.MSGCRC0005.name +
                  this.errorMsg.MSGCRC0005.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              }
              try {
                this.$store.dispatch('masters/writeLog', {
                  eventNumber,
                  eventType,
                  reason
                })
              } catch (error) {}
              this.showFailureModal = true
              this.showloadingModal = false
              e.target.value = ''
              return
            }
          } else {
            let eventNumber = this.$store.state.error.errorCode.errorCode_250005
            let reason = 'MSGCRC0128'
            let eventType = 9
            this.failureWord =
              this.errorMsg.MSGCRC0128.name +
              this.errorMsg.MSGCRC0128.value +
              'エラーコード：{' +
              eventNumber +
              '}'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.showFailureModal = true
            this.showloadingModal = false
            e.target.value = ''
            return
          }
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_250008
          let eventType = 9
          let reason = 'MSGCRC0053'
          this.failureWord =
            this.errorMsg.MSGCRC0053.name +
            this.errorMsg.MSGCRC0053.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.showFailureModal = true
          this.showloadingModal = false
          e.target.value = ''
        }
      }
      document.getElementById('photo_file_uploader').reset()
      this.showloadingModal = false
    },
    async isValidImageFile(file) {
      // ヘッダ部の簡易チェック
      return new Promise(resolve => {
        const fileReader = new FileReader()
        fileReader.onload = event => {
          const uint8Array = new Uint8Array(event.target.result)
          const isPNG =
            uint8Array[0] === 0x89 &&
            uint8Array[1] === 0x50 &&
            uint8Array[2] === 0x4e &&
            uint8Array[3] === 0x47
          const isJPEG =
            uint8Array[0] === 0xff &&
            uint8Array[1] === 0xd8 &&
            uint8Array[uint8Array.length - 2] === 0xff
          const isGIF =
            uint8Array[0] === 0x47 &&
            uint8Array[1] === 0x49 &&
            uint8Array[2] === 0x46 &&
            uint8Array[3] === 0x38 &&
            (uint8Array[4] === 0x37 || uint8Array[4] === 0x39) &&
            uint8Array[5] === 0x61
          if (isPNG || isJPEG || isGIF) {
            resolve(true)
          } else {
            resolve(false)
          }
        }
        fileReader.readAsArrayBuffer(file)
      })
    }
  }
}
</script>

<style scoped>
.detail_contents {
  padding-top: 25px;
}
.detail_top {
  padding-bottom: 30px;
}
.detail_top:before {
  height: 0px;
}
.uploader {
  top: 0;
  width: 100%;
  font-size: 10px;
}
/*-----------------------
  名前関連
-----------------------*/
.profile_content {
  width: 66%;
  display: inline-block;
  margin: 0 0 0 7%;
  vertical-align: middle;
}
.pronunciation {
  font-size: 14px;
  padding-bottom: 10px;
}
.careworker_name {
  width: 104%;
  font-size: 0px;
}
.family_name {
  border-radius: 3px 0 0 3px;
  border-right: none;
  width: 41%;
  vertical-align: middle;
}
.name {
  border-radius: 0 3px 3px 0;
  width: 42%;
  vertical-align: middle;
}
.memo {
  resize: vertical;
  min-height: 200px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/careworkers/careworkerEdit.vue